/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import { getBase64 } from 'bundles/page/lib/logo';

const SRC_PREFIX = 'data:image/svg+xml;base64,';

const styles = {
  image: css`
    height: 32px;
    width: 127px;
    ${breakpoints.down('xs')} {
      width: 108px;
    }
  `,
};

const CourseraHomeLogo = ({ logoColor = '#0056D2' }: { logoColor?: string }) => {
  const imgSrc = SRC_PREFIX + getBase64(logoColor);

  // We don't need to translate company name.
  // eslint-disable-next-line no-restricted-syntax
  return <img css={styles.image} src={imgSrc} alt="Coursera" />;
};

export default CourseraHomeLogo;
